import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { FeedSortType } from '@ai-platform/utils';

import { feedActions, useActions, useFeedSelector } from '../../../store';
import { getFeedSortFromSearchParams } from '../../../utils/url';

/**
 * Синхронизирует sort из URL search-параметров в стор при навигации.
 * Срабатывает при изменении searchParams (react-router навигация),
 * но не при прямом вызове setSort (т.к. setSearchParams с replace обновит
 * searchParams и эффект сработает корректно).
 */
export const useSyncSortFromUrl = () => {
    const { sort } = useFeedSelector();
    const { setSort } = useActions(feedActions);
    const [searchParams] = useSearchParams();

    useEffect(() => {
        const sortFromUrl = getFeedSortFromSearchParams(searchParams);
        const newSort = sortFromUrl ?? FeedSortType.All;

        if (newSort !== sort) {
            setSort(newSort);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [searchParams]);
};
